import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Licitacao } from '../_classes/licitacao';
import { Observable } from 'rxjs/Observable';
import { Arquivo } from '../_classes/arquivo';

import { URL } from '../_mocks/url';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { DadosPaginacao } from '../components/paginacao/dadosPaginacao';
import { LicitacaoFilter } from '../_classes/licitacaoFilter';

const httpOptionsSemAutenticacao = {
  headers: new HttpHeaders({'Content-Type': 'application/json' })
};

const httpOptionsComAutenticacao = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Authorization': localStorage.getItem('access_token'),
  })
};

@Injectable()
export class LicitacaoService {

  private urlLicitacao = URL + 'licitacao';

  constructor(
    private http: HttpClient
  ) { }

  //prepara a licitacao para ser salva/editada
  prepararLicitacao(licitacao: Licitacao): Licitacao {
    const licitacaoFinal: Licitacao = JSON.parse(JSON.stringify(licitacao))
    if (licitacaoFinal.valorLicitacao) {
      licitacaoFinal.valorLicitacao = licitacao.valorLicitacao.replace(/[a-zA-Z $]/g, '')
    }

    if (licitacaoFinal.arquivos) {
      licitacaoFinal.arquivos.forEach(arqivo => {
        if (arqivo.cnpj) {
          arqivo.cnpj.replace(/\.*\/*\-*/g, '')
        }
        if (arqivo.primeiroAditivo) {
          arqivo.primeiroAditivo = arqivo.primeiroAditivo.replace(/[a-zA-Z $]/g, '')
        }
        if (arqivo.segundoAditivo) {
          arqivo.segundoAditivo = arqivo.segundoAditivo.replace(/[a-zA-Z $]/g, '')
        }
      })
    }

    return licitacaoFinal
  }

  saveLicitacao(licitacao: Licitacao): Observable<Licitacao> {
    return this.http.post<Licitacao>(this.urlLicitacao, this.prepararLicitacao(licitacao), httpOptionsComAutenticacao);
  }

  uploadFile(id, arquivo: Arquivo) {
    const arquivoFinal = JSON.parse(JSON.stringify(arquivo))

    if (arquivoFinal.cnpj) {
      arquivoFinal.cnpj.replace(/\.*\/*\-*/g, '')
    }
    if (arquivoFinal.primeiroAditivo) {
      arquivoFinal.primeiroAditivo = arquivoFinal.primeiroAditivo.replace(/[a-zA-Z $]/g, '')
    }
    if (arquivoFinal.segundoAditivo) {
      arquivoFinal.segundoAditivo = arquivoFinal.segundoAditivo.replace(/[a-zA-Z $]/g, '')
    }

    const urlFinal = this.urlLicitacao + '/' + `${id}` + '/upload';
    return this.http.put<any>(urlFinal, arquivoFinal, httpOptionsComAutenticacao);
  }

  getLicitacoes(): Observable<Licitacao[]> {
    return this.http.get<Licitacao[]>(this.urlLicitacao, httpOptionsSemAutenticacao);
  }

  getLicitacaoById(id: number) {
    const urlFinal = this.urlLicitacao + '/' + `${id}`;
    return this.http.get<Licitacao>(urlFinal, httpOptionsSemAutenticacao);
  }

  editLicitacao(id: number, licitacao: Licitacao): Observable<Licitacao> {
    const urlFinal = this.urlLicitacao + '/' + `${id}`;
    return this.http.put<Licitacao>(urlFinal, this.prepararLicitacao(licitacao), httpOptionsComAutenticacao);
  }

  deleteLicitacao(id: number) {
    const urlFinal = this.urlLicitacao + '/' + `${id}`;
    return this.http.delete<any>(urlFinal, httpOptionsComAutenticacao);
  }

  getLicitacoesByPage(): Observable<Licitacao[]> {
    const urlFinal = this.urlLicitacao + '/limit';
    return this.http.get<Licitacao[]>(urlFinal, httpOptionsSemAutenticacao);
  }

  getArquivosDaLicitacao(id: number): Observable<Arquivo[]> {
    const urlFinal = this.urlLicitacao + `/${id}/load/files`;
    return this.http.get<Arquivo[]>(urlFinal, httpOptionsSemAutenticacao);
  }

  getValorDoArquivoPorId(id: number): Observable<any> {
    const urlFinal = URL + `arquivo/value/${id}`;
    return this.http.get<any>(urlFinal);
  }

  getLicitacoesByFilter(filter, dadosPaginacao?: DadosPaginacao): Observable<Licitacao[]> {
    const urlFinal = this.urlLicitacao + '/filter';
    const paginationQueryParams = this.dadosPaginacaoToQueryParam(dadosPaginacao);

    return this.http.post<Licitacao[]>(urlFinal, filter, {
      params: paginationQueryParams
    });
  }

  getTotalEntidades(licitacaoFilter: LicitacaoFilter): Observable<number> {
    return this.http.post<number>(`${this.urlLicitacao}/total-registros`, licitacaoFilter, httpOptionsSemAutenticacao);
  }

  dadosPaginacaoToQueryParam(dadosPaginacao: DadosPaginacao): { [key: string]: string } {
    if (!dadosPaginacao) {
      return {};
    }

    const paginacaoQueryParam = {};

    if (dadosPaginacao) {
      paginacaoQueryParam['page'] = dadosPaginacao.page;
      paginacaoQueryParam['size'] = dadosPaginacao.size;
    }

    return paginacaoQueryParam;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/licitacao.service.ts